"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShareData = getShareDataWithCache;
exports.getUserInfo = getUserInfo;
const { useUser } = require('@fegobull/webapi').use;
const { uid } = useUser();
const { request } = require('@futuweb/fego-render').common;
/**
 * 获取 commonApi 实例
 * 使用函数形式获取，避免组件卸载后 commonApi 被标记为 uninstalled
 * 同一页面多个组件实例时，每次调用都能获取有效的 API 实例
 */
function getCommonApi() {
    return request.bindCommonApi('common-redpacket-share');
}
// 创建uuid
const cacheKey = 'common-redpacket-share-data:W4IbiX';
class ShareStorage {
    constructor(shareConfig) {
        const pathname = window.location.pathname;
        const globalContent = new URLSearchParams(window.location.search).get('global_content');
        const key = `${cacheKey}:${pathname}:${shareConfig}:${uid}:${globalContent}`;
        this.key = key;
    }
    get() {
        return localStorage.getItem(this.key) || '';
    }
    set(value) {
        localStorage.setItem(this.key, value);
    }
}
function getShareDataOnline(shareConfig) {
    return getCommonApi().post('get-share-data', {
        referer: window.location.href,
        shareConfig
    }, {
        group: null // 不需要限制请求频次
    });
}
async function getUserInfo() {
    return getCommonApi().get('get-user-info');
}
/**
 * 获取分享数据
 * @param shareConfig 分享配置
 * @param retry 重试次数
 * @returns 分享数据
 */
async function getShareData(shareConfig, retry = 3) {
    const localStorage = new ShareStorage(shareConfig);
    if (localStorage.get()) {
        return localStorage.get();
    }
    try {
        const onlineData = await getShareDataOnline(shareConfig);
        if (onlineData.shortUrl) {
            localStorage.set(onlineData.shortUrl);
        }
        return onlineData.shortUrl;
    }
    catch (error) {
        if (retry > 0) {
            return getShareData(shareConfig, retry - 1);
        }
        throw error;
    }
}
async function getShareDataWithCache(shareConfig) {
    const key = `${cacheKey}:${shareConfig}`;
    if (window[key]) {
        return window[key];
    }
    window[key] = getShareData(shareConfig);
    return window[key];
}
//# sourceMappingURL=data:application/json;base64,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